import React, { MouseEvent } from 'react';

export type ModalContextState = {
	handleOnClose?: (event: MouseEvent) => void;
};

export default React.createContext<ModalContextState>({});
